const FormatEventTimeFilter = function () {
  return function (time) {
    if (!time) {
      return time;
    }
    var splits = time.split(":");
    return splits[ 0 ] + ":" + splits[ 1 ];
  };
};

export default FormatEventTimeFilter;